/**
 * Zona waktu tenant, dipasang sekali sesudah masuk.
 *
 * KENAPA PROVIDER, BUKAN PANGGILAN DI TIAP LAYAR. `tanggal()`, `jam()`, dan
 * `sejak()` fungsi murni yang dipanggil saat render; tidak satu pun komponen
 * berlangganan pada zonanya. Kalau tiap layar memanggil rutenya sendiri, layar yang
 * lupa memanggil akan menampilkan jam zona lain TANPA terlihat berbeda — dan itu
 * kelas cacat yang tidak akan pernah ditangkap siapa pun dari layar.
 *
 * SATU PENDENGAR DI ATAS SELURUH POHON. Zona tiba sesudah gambar pertama, jadi
 * tanggal yang sudah dirender harus digambar ulang. Yang dilakukan di sini cuma
 * `setState` biasa — pohonnya dirender ulang, BUKAN di-remount, jadi tab yang sedang
 * dibuka dan isian yang sedang diketik tetap utuh. `key` yang berubah akan
 * membuangnya semua.
 *
 * OPERATOR SMOVA SENGAJA TIDAK IKUT. Ia berdiri di luar semua tenant, dan rute ini
 * menuntut `X-Tenant-Id` darinya — tidak ada satu zona yang benar untuk konsol yang
 * menampilkan banyak tenant sekaligus. Yang menyebut tenantnya adalah layar detail
 * tenant, dan layar itu yang memasang zonanya sendiri.
 */
import { useEffect, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useTenantIni } from '../domains/tenancy/api'
import { dengarZona, setZonaTenant, zonaTenant } from '../shared/lib/waktu'
import { useSesi } from './auth'

export function PenyediaZona({ children }) {
  const { sesi } = useSesi()
  const punyaTenantSendiri = !!sesi && sesi.peran !== 'smova_admin'

  const [, gambarUlang] = useState(zonaTenant)
  useEffect(() => dengarZona(gambarUlang), [])

  const q = useTenantIni(null, punyaTenantSendiri)

  useEffect(() => {
    if (q.data?.timezone) setZonaTenant(q.data.timezone)
  }, [q.data?.timezone])

  // KELUAR MEMBUANG DUA HAL, dan yang kedua tidak kelihatan sampai ada tenant kedua.
  //
  // Pertama zonanya: kalau tidak, zona tenant sebelumnya masih terpasang saat orang
  // lain masuk di tab yang sama, dan jamnya salah sejak gambar pertama — sebelum
  // permintaan di atas sempat menjawab.
  //
  // Kedua hasil kuerinya. `staleTime: Infinity` membuat TanStack menjawab dari cache
  // tanpa pernah meminta ulang; kuncinya tidak memuat identitas orang, jadi masuk
  // sebagai tenant LAIN akan mengembalikan zona tenant sebelumnya dari cache dan
  // tidak pernah menyegarkannya. Membuang zonanya saja tidak cukup: effect di atas
  // akan memasangnya kembali dari data basi itu juga.
  //
  // Ini menyentuh kunci `['tenant', 'ini']` SAJA. Sisa cache tenant lama juga masih
  // bertahan melewati keluar-masuk — itu cacat yang lebih luas dan bukan milik berkas
  // ini; dicatat di BUGS_PENDING, bukan diperbaiki diam-diam di sini.
  const qc = useQueryClient()
  useEffect(() => {
    if (sesi) return
    setZonaTenant(null)
    qc.removeQueries({ queryKey: ['tenant', 'ini'] })
  }, [sesi, qc])

  return children
}
